import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

const CoalitionTrending = () => {
  const { coalitionId } = useParams();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://public.tableau.com/javascripts/api/viz_v1.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      className="tableauPlaceholder"
      id="viz1785166502478"
      style={{ position: "relative" }}
    >
      <object
        className="tableauViz"
        style={{ display: "none", width: "100%", height: 991 }}
      >
        <param name="host_url" value="https%3A%2F%2Fpublic.tableau.com%2F" />
        <param name="embed_code_version" value="3" />
        <param name="site_root" value="" />
        <param name="name" value="Coalition_Trending&#47;COALITIONMAP" />
        <param name="tabs" value="no" />
        <param name="toolbar" value="yes" />
        <param
          name="static_image"
          value="https:&#47;&#47;public.tableau.com&#47;static&#47;images&#47;Co&#47;Coalition_Trending&#47;COALITIONMAP&#47;1.png"
        />
        <param name="animate_transition" value="yes" />
        <param name="display_static_image" value="yes" />
        <param name="display_spinner" value="yes" />
        <param name="display_overlay" value="yes" />
        <param name="display_count" value="yes" />
        <param name="language" value="en-US" />
        <param name="filter" value="publish=yes" />
        <param
          name="filter"
          value={`CoalitionID Parameter=${coalitionId || 14}`}
        />
      </object>
    </div>
  );
};

export default CoalitionTrending;
